import { MetaTagsProps, useMetaTags } from "../hooks";

export const MetaTags: React.FC<MetaTagsProps> = (props) => {
  useMetaTags(props);
  return null;
};
